import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class TeamSeasonDeleted extends DomainEvent<DeletedEntity> {}
